import { useQuery } from "@tanstack/react-query";
import type { UseQueryOptions } from "@tanstack/react-query";

import type { GoalAndObjectiveTextResponse } from "@/core/types";

import { getGoalAndObjectiveText } from "../queryFunctions/getGoalAndObjectiveText";
import { memberCarePlanKeys } from "../keyFactory";

type UseGoalAndObjectiveTextProps<TData = GoalAndObjectiveTextResponse> = {
  patientId: string;
  select?: (data: GoalAndObjectiveTextResponse) => TData;
};

type GoalAndObjectiveTextQueryOptions = UseQueryOptions<
  GoalAndObjectiveTextResponse,
  unknown,
  GoalAndObjectiveTextResponse,
  ReturnType<typeof memberCarePlanKeys.goalAndObjectiveText>
>;

export function useGoalAndObjectiveText<TData = GoalAndObjectiveTextResponse>({
  patientId,
  select,
}: UseGoalAndObjectiveTextProps<TData>) {
  return useQuery({
    ...optionFactory(patientId),
    select,
  });
}

export function optionFactory(patientId: string) {
  return {
    queryFn: () => getGoalAndObjectiveText(patientId),
    queryKey: memberCarePlanKeys.goalAndObjectiveText(patientId),
  } satisfies GoalAndObjectiveTextQueryOptions;
}
